import { config } from '../config';
import { setSsoSession } from './session';
const buildUrl = (req) => {
    const params = new URLSearchParams({ flow: req.flow });
    if (req.flow === 'cognito') {
        params.set('provider', req.provider);
        if (req.loginHint)
            params.set('hint', req.loginHint);
    }
    else if (req.flow === 'auth0') {
        params.set('connection', req.connection);
        if (req.loginHint)
            params.set('hint', req.loginHint);
    }
    else {
        params.set('org', req.organisationID);
    }
    return `${config.addinOrigin}/authdialog.html?${params}`;
};
/**
 * Opens the Office Dialog API at our own /authdialog page, which runs the requested login and
 * posts the resulting token back via `messageParent`.
 *
 * The dialog ALWAYS starts and ends on the add-in's origin, whatever provider it visits in
 * between: `messageParent` is only callable from a page on the add-in's own origin, so a token
 * that lands anywhere else (the web app, Cognito, a customer IdP) is unreachable from here.
 */
export function loginWithSso(req) {
    return new Promise((resolve, reject) => {
        Office.context.ui.displayDialogAsync(buildUrl(req), { height: 60, width: 40, promptBeforeOpen: false }, (asyncResult) => {
            if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                return reject(new Error(asyncResult.error.message));
            }
            const dialog = asyncResult.value;
            let settled = false;
            dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
                settled = true;
                try {
                    const payload = JSON.parse(arg.message);
                    if (payload.error)
                        throw new Error(payload.error);
                    if (!payload.idToken)
                        throw new Error('No token in dialog response');
                    setSsoSession(payload.idToken, payload.source ?? 'sso', payload.expiresIn, payload.refreshToken);
                    dialog.close();
                    resolve();
                }
                catch (e) {
                    dialog.close();
                    reject(e);
                }
            });
            // Fires when the user closes the dialog themselves, and also after our own close() on
            // some hosts — `settled` keeps that from rejecting an already-resolved login.
            dialog.addEventHandler(Office.EventType.DialogEventReceived, () => {
                if (!settled)
                    reject(new Error('Sign-in was cancelled'));
            });
        });
    });
}
